import script from "./IOrderEventItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IOrderEventItem.vue?vue&type=script&setup=true&lang=js"

import "./IOrderEventItem.vue?vue&type=style&index=0&id=d70b1638&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d70b1638"]])

export default __exports__